import React, { useEffect, useState } from "react";
import {
  addPosition,
  updatePosition,
  deletePosition,
  deletePositions,
} from "../../api/position/positionUpdateApi";
import { errorStatusHandle } from "../../utils";
import BackendLayout from "../../layouts/BackendLayout";
import Table from "../../components/table/Table";
import Pagination from "../../components/Pagination";
import {
  AddPositionModal,
  UpdatePositionModal,
  ConfirmDeletePositionModal,
} from "../../components/positions";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import { POSITION_MASTER_UPDATE } from "../../constants/routes";
import { PageTitle } from "../../components/admin";
import { useDocumentTitle, useGetPositions } from "../../hooks";
import { getPositionUpdatePageSettings } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import { useDispatch } from "react-redux";
import PageAlert from "../../components/alerts/PageAlert";
import {
  clearPageLoading,
  setAlertSuccess,
  setPageLoading,
  clearButtonProcessing,
  setButtonProcessing,
} from "../../store/actions";
import { FeatureSpan } from "../../components/labels";
import { formatFeatures } from "../../services/PositionServices";
import {
  ButtonTableDelete,
  ButtonTableEdit,
  ButtonTableBulkDelete,
  ButtonAdd,
  CheckboxInput,
  ButtonBack,
  ButtonDPad,
  RedirectAlert,
} from "../../components";
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import HintIconToolTip from "../../components/HintIconToolTip";
import {POSITION_MASTER_UPDATE_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

function PositionUpdatePage() {
  useRedirectPage(POSITION_MASTER_UPDATE_PAGE);
  useDocumentTitle("職位マスタ更新 - 点検王");
  const dispatch = useDispatch();
  const breadcrumb = getRouteBreadcrumb(POSITION_MASTER_UPDATE);
  const [showAddPositionModal, setShowAddPositionModal] = useState(false);
  const [showUpdatePositionModal, setShowUpdatePositionModal] = useState(false);
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [positionForm, setPositionForm] = useState({});
  const [updateDeleteId, setUpdateDeleteId] = useState(0);
  const [buttonDeleteId, setButtonDeleteId] = useState("");
  const [deleteIds, setDeleteIds] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [isModalMessage, setIsModalMessage] = useState(false);
  const [reload, setReload] = useState(0);
  const [features, setFeatures] = useState({});
  const [confirmDeleteMessage, setConfirmDeleteMessage] = useState([]);
  const [confirmDeleteTitle, setConfirmDeleteTitle] = useState("");
  const [listNameDelete, setListNameDelete] = useState([]);
  const [processing, setProcessing] = useState(false);
  const {
    positions,
    page,
    perPage,
    totalCount,
    sort,
    setPositions,
    setPage,
    setPerPage,
    setSort,
  } = useGetPositions(reload);

  const setPositionUpdatePageSettings = async (e) => {
    dispatch(setPageLoading());
    const pageSettings = await getPositionUpdatePageSettings();
    dispatch(setPageSettings(pageSettings));
    setFeatures(formatFeatures(pageSettings.features));
    dispatch(clearPageLoading());
  };
  useEffect(() => {
    setPositionUpdatePageSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSort = (column) => {
    let newSort = { ...sort };
    if (newSort.hasOwnProperty(column)) {
      if (newSort[column] === -1) {
        delete newSort[column];
      } else if (newSort[column] === 1) {
        newSort[column] = -1;
      }
    } else {
      newSort[column] = 1;
    }
    setSort(newSort);
  };

  // Add Position
  const handleShowAddModal = () => {
    setErrorMessage("");
    setErrors({});
    setPositionForm({
      permission_no: "1",
      name: "",
      description: "",
      template_management: 0,
      approval_setting_management: 0,
      machine_management: 0,
      machine_group_management: 0,
      department_management: 0,
      position_management: 0,
    });
    setShowAddPositionModal(true);
  };

  const handleShowUpdateModal = (row) => {
    setErrorMessage("");
    setErrors({});
    setUpdateDeleteId(row.id);
    setPositionForm({
      permission_no: row.permission_no,
      name: row.name,
      description: row.description,
      template_management: row.permissions.template_management,
      approval_setting_management: row.permissions.approval_setting_management,
      machine_management: row.permissions.machine_management,
      machine_group_management: row.permissions.machine_group_management,
      department_management: row.permissions.department_management,
      position_management: row.permissions.position_management,
    });
    setShowUpdatePositionModal(true);
  };

  const handleShowDeleteModal = (id = 0, name = "") => {
    if (id === 0 && deleteIds.length === 0) {
      return;
    }
    if (id === 0 && deleteIds.length !== 0 && listNameDelete.length !== 0) {
      let confirmTitle = "職位を一括削除しますか？";
      let confirmMessage = [
        "選択された以下の職位を削除します。",
        "この操作は元には戻せません",
        "",
      ];
      listNameDelete.forEach((item) => {
        if (item.length > 32) {
          confirmMessage.push("職位の名前：", item);
        } else {
          confirmMessage.push(`職位の名前：${item}`);
        }
      });
      setStateForDelete(id, confirmTitle, confirmMessage);
    }
    if (id !== 0 && name !== "") {
      let confirmTitle = "職位を削除しますか？";
      let confirmMessage = [`職位の名前：${name}を削除します。`];
      if (name.length > 25) {
        confirmMessage = ["職位の名前：", `${name}を削除します。`];
      }
      confirmMessage.push("この操作は元には戻せません。");
      setStateForDelete(id, confirmTitle, confirmMessage);
    }
  };

  const setStateForDelete = (id, confirmTitle, confirmMessage) => {
    confirmMessage.push("", "削除してもよろしいでしょうか？");
    setUpdateDeleteId(id);
    setConfirmDeleteTitle(confirmTitle);
    setConfirmDeleteMessage(confirmMessage);
    setButtonDeleteId(`button__delete-position--${id}`);
    setShowConfirmDeleteModal(true);
  };

  const handleCheckboxChange = (id, name, e) => {
    const isChecked = e.target.checked;
    const updatedDeleteIds = isChecked
      ? [...deleteIds, id]
      : deleteIds.filter((positionId) => positionId !== id);
    const updateDeleteName = isChecked
      ? [...listNameDelete, name]
      : listNameDelete.filter((positionName) => positionName !== name);
    const updatedTableData = positions.map((item) => {
      if (item.id === id) {
        return { ...item, delete: isChecked };
      }
      return item;
    });
    setListNameDelete(updateDeleteName);
    setDeleteIds(updatedDeleteIds);
    setPositions(updatedTableData);
  };

  const BUTTON_CREATE_POSITION = "button__crate-position";
  const handleAddPosition = () => {
    dispatch(setButtonProcessing(BUTTON_CREATE_POSITION));
    addPosition(positionForm)
      .then((response) => {
        afterCRUDSuccess(response);
        setShowAddPositionModal(false);
      })
      .catch((error) => {
        afterCRUDError(error);
        setIsModalMessage(true);
      })
      .finally(() => {
        dispatch(clearButtonProcessing(BUTTON_CREATE_POSITION));
      });
  };

  const BUTTON_UPDATE_POSITION = "button__update-position";
  const handleUpdatePosition = () => {
    dispatch(setButtonProcessing(BUTTON_UPDATE_POSITION));
    updatePosition(updateDeleteId, positionForm)
      .then((response) => {
        afterCRUDSuccess(response);
        setShowUpdatePositionModal(false);
      })
      .catch((error) => {
        afterCRUDError(error);
        setIsModalMessage(true);
      })
      .finally(() => {
        dispatch(clearButtonProcessing(BUTTON_UPDATE_POSITION));
      });
  };

  const handleDeletePosition = () => {
    dispatch(setButtonProcessing(buttonDeleteId));
    if (updateDeleteId === 0 && deleteIds.length > 0) {
      deletePositions(deleteIds)
        .then((response) => {
          afterCRUDSuccess(response);
          setDeleteIds([]);
          setListNameDelete([]);
          setShowConfirmDeleteModal(false);
        })
        .catch((error) => {
          afterCRUDError(error);
          setIsModalMessage(false);
          setShowConfirmDeleteModal(false);
        })
        .finally(() => {
          dispatch(clearButtonProcessing(buttonDeleteId));
        });
    } else {
      deletePosition(updateDeleteId)
        .then((response) => {
          afterCRUDSuccess(response);
          setDeleteIds([]);
          setListNameDelete([]);
          setShowConfirmDeleteModal(false);
        })
        .catch((error) => {
          afterCRUDError(error);
          setIsModalMessage(false);
          setShowConfirmDeleteModal(false);
        })
        .finally(() => {
          dispatch(clearButtonProcessing(buttonDeleteId));
        });
    }
  };

  const afterCRUDSuccess = (response) => {
    setReload(reload + 1);
    dispatch(setAlertSuccess(response.message));
    setErrorMessage("");
    setErrors({});
    setIsModalMessage(false);
    setProcessing(false);
  };

  const afterCRUDError = (error) => {
    errorStatusHandle(error);
    if (error.status === 400) {
      let responseData = error.data;
      setErrorMessage(responseData.error_message);
      setErrors(responseData.errors);
    }
    setProcessing(false);
  };

  const goBack = () => {
    window.history.back();
  };

  //Message
  const renderMessages = () => {
    if (errorMessage.length > 0) {
      return <div className="error-block mb-[16px] mt-0">{errorMessage}</div>;
    }
    return;
  };

  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <PageTitle title="職位マスタ更新" />
      <RedirectAlert />
      <PageAlert />
      <div className="2xl:hidden">
        <ButtonDPad />
      </div>
      <div className="min-w-full w-fit pr-6">
        {isModalMessage ? null : renderMessages()}
        <div className="rounded-lg border border-tenken-gray-300">
          <Table striped>
            <Table.Head>
              <Table.HeadCell
                sortable="true"
                order={sort.permission_no}
                onChangeOrder={() => handleSort("permission_no")}
                childclass="justify-center"
                className="w-[98px] normal-case"
              >
                権限No.
              </Table.HeadCell>
              <Table.HeadCell
                sortable="true"
                order={sort.name}
                onChangeOrder={() => handleSort("name")}
              >
                職位の名前
              </Table.HeadCell>
              {features.template_management && (
                <Table.HeadCell className="whitespace-nowrap text-center w-[178px]">
                  {features.template_management}
                </Table.HeadCell>
              )}
              {features.approval_setting_management && (
                <Table.HeadCell className="whitespace-nowrap text-center w-[146px]">
                  {features.approval_setting_management}
                </Table.HeadCell>
              )}
              {features.machine_management && (
                <Table.HeadCell className="whitespace-nowrap text-center w-[162px]">
                  {features.machine_management}
                </Table.HeadCell>
              )}
              {features.machine_group_management && (
                <Table.HeadCell className="whitespace-nowrap text-center w-[226px]">
                  {features.machine_group_management}
                </Table.HeadCell>
              )}
              {features.department_management && (
                <Table.HeadCell className="whitespace-nowrap text-center w-[162px]">
                  {features.department_management}
                </Table.HeadCell>
              )}
              {features.position_management && (
                <Table.HeadCell className="whitespace-nowrap text-center w-[162px]">
                  {features.position_management}
                </Table.HeadCell>
              )}
              <Table.HeadCell className="w-[120px]"></Table.HeadCell>
              <Table.HeadCell className="w-[92px]">
                <ButtonTableBulkDelete
                  type="button"
                  onClick={() => handleShowDeleteModal()}
                />
              </Table.HeadCell>
            </Table.Head>
            <Table.Body className="devide-y text-base">
              <LoadingSpinner component="position_update" />
              {positions.map((row, idx) => (
                <Table.Row
                  key={idx}
                  className={row.delete ? "!bg-[#FFE7E7]" : ""}
                >
                  <Table.Cell className="text-center">
                    <span>{row.permission_no}</span>
                  </Table.Cell>
                  <Table.Cell className="flex items-center whitespace-nowrap max-w-[280px]">
                    <span title={row.name} className="truncate">
                      {row.name}
                    </span>
                    {row.description && (
                      <div className="flex-shrink-0">
                        <HintIconToolTip>{row.description}</HintIconToolTip>
                      </div>
                    )}
                  </Table.Cell>
                  {features.template_management && (
                    <Table.Cell className="text-center">
                      <FeatureSpan
                        level={row.permissions.template_management}
                      />
                    </Table.Cell>
                  )}
                  {features.approval_setting_management && (
                    <Table.Cell className="text-center">
                      <FeatureSpan
                        level={row.permissions.approval_setting_management}
                      />
                    </Table.Cell>
                  )}
                  {features.machine_management && (
                    <Table.Cell className="text-center">
                      <FeatureSpan level={row.permissions.machine_management} />
                    </Table.Cell>
                  )}
                  {features.machine_group_management && (
                    <Table.Cell className="text-center">
                      <FeatureSpan
                        level={row.permissions.machine_group_management}
                      />
                    </Table.Cell>
                  )}
                  {features.department_management && (
                    <Table.Cell className="text-center">
                      <FeatureSpan
                        level={row.permissions.department_management}
                      />
                    </Table.Cell>
                  )}
                  {features.position_management && (
                    <Table.Cell className="text-center">
                      <FeatureSpan
                        level={row.permissions.position_management}
                      />
                    </Table.Cell>
                  )}
                  <Table.Cell>
                    <div className="flex justify-center align-center">
                      <ButtonTableEdit
                        className="mr-[8px]"
                        type="button"
                        onClick={() => handleShowUpdateModal(row)}
                      />
                      <ButtonTableDelete
                        disabled={!row.can_delete}
                        type="button"
                        onClick={() => handleShowDeleteModal(row.id, row.name)}
                      />
                    </div>
                  </Table.Cell>
                  <Table.Cell>
                    <CheckboxInput
                      position="justify-center"
                      name="delete"
                      checked={row.delete}
                      disabled={!row.can_delete}
                      onChange={(e) =>
                        handleCheckboxChange(row.id, row.name, e)
                      }
                    />
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
        <div className="w-full md:mt-3 xl:mt-6">
          <div className="xl:flex xl:items-center xl:space-x-2">
            <ButtonAdd onClick={() => handleShowAddModal()}>追加</ButtonAdd>
            <div className="xl:mt-0 mt-3 w-full">
              <Pagination
                setPage={setPage}
                currentPage={page}
                setPageSize={setPerPage}
                pageSize={perPage}
                totalCount={totalCount}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6 py-2.5 w-full flex justify-center space-x-[200px] mb-4">
        <ButtonBack onClick={goBack} />
      </div>
      <AddPositionModal
        openModal={showAddPositionModal}
        setOpenModal={setShowAddPositionModal}
        positionForm={positionForm}
        setPositionForm={setPositionForm}
        submitHandler={handleAddPosition}
        errors={errors}
        features={features}
        buttonId={BUTTON_CREATE_POSITION}
      >
        {isModalMessage ? renderMessages() : null}
      </AddPositionModal>
      <UpdatePositionModal
        openModal={showUpdatePositionModal}
        setOpenModal={setShowUpdatePositionModal}
        positionForm={positionForm}
        setPositionForm={setPositionForm}
        submitHandler={handleUpdatePosition}
        errors={errors}
        features={features}
        buttonId={BUTTON_UPDATE_POSITION}
      >
        {isModalMessage ? renderMessages() : null}
      </UpdatePositionModal>
      <ConfirmDeletePositionModal
        openModal={showConfirmDeleteModal}
        setOpenModal={setShowConfirmDeleteModal}
        submitHandler={handleDeletePosition}
        title={confirmDeleteTitle}
        content={confirmDeleteMessage}
        buttonId={buttonDeleteId}
      />
    </BackendLayout>
  );
}

export default PositionUpdatePage;
